import { memo } from "react";
import { AxisLeft } from "@visx/axis";
import { format } from "d3";
import type { ScaleLinear } from "d3-scale";
import { AxisGElement } from "./styles";
import { formatYAxisValue } from "@atlas-int/data";
import { OverTimeLayoutOption } from "../charts/overtime/Utils";

interface YAxisProps {
  scale: ScaleLinear<number, number>;
  chartMargin: { left: number; right: number; top: number; bottom: number };
  overTimeLayout?: OverTimeLayoutOption;
}

const YAxis = ({ scale, chartMargin, overTimeLayout }: YAxisProps) => {
  const tickFormat =
    overTimeLayout === OverTimeLayoutOption.Share
      ? (value: number) => format(".0%")(value)
      : (value: number) => "$" + formatYAxisValue(value);

  return (
    <AxisGElement transform={`translate(${chartMargin.left}, 0)`}>
      <AxisLeft
        scale={scale}
        numTicks={10}
        tickFormat={tickFormat}
        hideAxisLine
        hideTicks
      />
    </AxisGElement>
  );
};

export default memo(YAxis);
